import { render } from "./VirScheduleView.vue?vue&type=template&id=2b2eff3a&scoped=true"
import script from "./VirScheduleView.vue?vue&type=script&lang=js"
export * from "./VirScheduleView.vue?vue&type=script&lang=js"

import "./VirScheduleView.vue?vue&type=style&index=0&id=2b2eff3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2eff3a"]])

export default __exports__